//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
import * as moment from 'moment'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { DashboardChartDataModel, DashboardChartSeriesPoint, MeasurementsRequestModel, MeasurementModel, DescrModel, DashboardChartSeries, DashboardModel } from '../../api/api.models'
import { MeasureCollection } from '../../../models/custom/measure-collection'
import { CommonHelper, ChartType, PieChartType, CorrelationType } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { i18n } from '../../common/i18n/common.i18n'
import { IUserSession } from '../../../helpers/user-session'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { ButtonListOptions } from '../../common/button-list/button-list.directive'
import { MeasurementsController } from '../../common/measurements/measurements.controller'
import { TableController } from '../../common/common.table.controller'
import { IMeasurementsService } from '../../common/measurements/measurements.service'
import { Enums } from '../../../models/common/enums'
import { DashboardRefreshControlDelay, DashboardDelay } from '../dashboard.controller'
import { TemplateHelper, ConfigHelper, LocalizationHelper } from '../../../helpers'
import { SystemService } from '../../../services/system'
import { IMRBaseControlDirectiveController } from '../../../modules/common/base'
import { DataProviderRequest } from 'app/data-provider'

class SeriesTypeNames {
    static Date = "System.Date"
    static Time = "System.Time"
    static DateTime = "System.DateTime"
    static Double = "System.Double"
}

class HorizontalAlignment {
    static Left: 'left' = 'left'
    static Center: 'center' = 'center'
    static Right: 'right' = 'right'
}

class VerticalAlignment {
    static Top = 'top'
    static Middle = 'middle'
    static Bottom = 'bottom'
}

interface Info { dataType: number, idLoc: number, IdMeter: number, serialNbr: number }
interface iSort {
    info: Info,
    measurements: MeasurementModel[]
}

interface ChartScope extends ng.IScope {
    // from directive
    data: DashboardChartDataModel // ??
    itemTitle: string
    fitToScreen: boolean
    isEditMode: boolean
    dashboardModel: DashboardModel

    chartWithTableClass: string

    // others
    options: any // chart options
    isLineChart: boolean
    isChartFullscreen: boolean
    isLegendVisible: boolean
    isDataSourceEmpty: boolean
    legendButtonOptions: DevExpress.ui.dxButtonOptions
    resizeButtonOptions: DevExpress.ui.dxButtonOptions

    exportGridButtonOptions: DevExpress.ui.dxButtonOptions
    refreshButtonOptions: DevExpress.ui.dxButtonOptions

    datesPopupOptions: DevExpress.ui.dxPopupOptions
    datesPopupToolbarOptions: DevExpress.ui.dxToolbarOptions

    // positioning
    positionButtonListOptions: ButtonListOptions
    positionPopoverOptions: DevExpress.ui.dxPopoverOptions
    positionListOptions: DevExpress.ui.dxListOptions

    // preferences
    preferencesButtonListOptions: ButtonListOptions
    preferencesPopoverOptions: DevExpress.ui.dxPopoverOptions
    preferencesListOptions: DevExpress.ui.dxListOptions

    // hamburger / settings list
    settingsButtonListOptions: ButtonListOptions

    resizeChart: () => void

    datePickerBridge: any //??
    chartHeight: any //??

    gridOptions: GridOptions

    isSmallScreen: boolean
    loading: boolean

    isLegendButtonHidden: boolean
    isFullscreenButtonHidden: boolean
}

export class ChartDirectiveController extends IMRBaseControlDirectiveController {
    private static colors = ['red', 'blue', '#008000', '#6600cc', 'green', 'yellow', 'purple']
    private static regexp = new RegExp("^ *[0-9]{1,3} *, *[0-9]{1,3} *, *[0-9]{1,3} *$", "g")

    private GRID_TYPES = {
        IN_COLUMNS: { template: CommonHelper.getTemplateforListRow(i18n('Grid', 'DataTypeColumns'), 'context-menu-row'), id: "data-type-columns" },
        IN_ROWS: { template: CommonHelper.getTemplateforListRow(i18n('Grid', 'DataTypeRows'), 'context-menu-row'), id: "data-type-rows" },
        FIX_COLUMNS: { template: CommonHelper.getTemplateforListRow(i18n('Grid', 'ColumnFixing'), 'context-menu-row', '', 'FORMAT_INCREASE'), id: "column-auto-width" }
    }

    private loadLatest: boolean
    private referenceType: number
    private referenceValues: number[]
    private selectedPeriod: any
    private legendButton: DevExpress.ui.dxButton
    private chart: DevExpress.viz.dxChart

    private grid: DevExpress.ui.dxDataGrid = null
    private gridId: number

    private actualSeries: DashboardChartSeries[]
    private actualMeasurements: MeasureCollection[]

    private clickTimer: any

    private sourceUpdating: boolean

    constructor(
        private $scope: ChartScope,
        private $timeout: ng.ITimeoutService,
        private $element: JQuery,
        private $state: StateService,
        private $q: ng.IQService,
        private api: Api,
        private localDictionary: LocalDictionaryFactory,
        private userSession: IUserSession,
        private measurements: IMeasurementsService,
        private systemService: SystemService
    ) {
        super()

        var data: DashboardChartDataModel = $scope.data
        if (!data)
            data = <any>{}

        const id: number = new Date().getTime()

        this.actualSeries = data.series

        var hasZeroValue = false
        var series = []
        var parent = null
        $scope.isChartFullscreen = false

        $scope.$on('dashboard-refresh', () => {
            if (this.chart) {
                this.chart.render()
            }
        })

        $scope.$on(EventsNames.UPDATE_DASHBOARD_ITEM + data.id, (event, ...args) => {
            if (args[0]) {
                data = _.assign({}, args[0])
            }
            createChart()
            $timeout(() => {
                try {
                    if (this.chart) {
                        this.chart.option($scope.options)
                        this.chart.render()
                    }
                } catch (e) {
                    console.warn('Unable render chart.')
                }
            }, 500)
        })

        $scope.legendButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.LEGEND, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Legend),
            onInitialized: e => {
                this.legendButton = e.component
            },
            onClick: (e) => {
                $scope.isLegendVisible = !$scope.isLegendVisible
                if ($scope.isLegendVisible) {
                    e.element.addClass('dx-state-focused')
                } else {
                    e.element.removeClass('dx-state-focused')
                }
                //OperatorLayoutSettings.setSetting(OperatorLayoutSettings.IsLegendVisible, $scope.isLegendVisible)
                this.chart.option('legend.visible', $scope.isLegendVisible)
                if (!$scope.isLegendVisible) {
                    $timeout(() => {
                        this.chart.render()
                    })
                }
            }
        }

        $scope.resizeChart = () => {
            $scope.isChartFullscreen = !$scope.isChartFullscreen
            angular.element('.navbar-fixed-top').toggleClass("fixed")
            if ($scope.isChartFullscreen) {
                parent = $element.parent()
                $element.appendTo('body')
                this.chart.option('size', { height: '100%' })
            } else {
                $element.appendTo(parent)
                this.chart.option('size', { height: '100%' })
            }
            $timeout(() => {
                this.chart.render()
                if (this.grid)
                    this.grid.updateDimensions()
            }, 500)
        }

        $(document).keydown((e) => {
            if (e.keyCode == 27) {
                if ($scope.isChartFullscreen) {
                    $scope.resizeChart()
                }
            }
        })

        $scope.datePickerBridge = {
            fromDate: null,
            toDate: null,
            callback: (selectedPeriod) => {
                this.selectedPeriod = selectedPeriod
                this.refreshMeasurements()
            },
            customPeriods: [
                {
                    id: "latest",
                    title: i18n('Common', 'Latest')
                }
            ],
            isSmallScreen: false
        }

        var createChart = () => {
            let axisXType: string = 'string'

            if (data.series && data.series.length > 0) {
                if (data.series[0].xTypeName == SeriesTypeNames.DateTime) axisXType = 'datetime'
                if (data.series[0].xTypeName == SeriesTypeNames.Date) axisXType = 'date'
                if (data.series[0].xTypeName == SeriesTypeNames.Time) axisXType = 'time'
            }

            const firstSerieChartType = data.series.length > 0 ? data.series[0].seriesType : 'line'

            $scope.isLegendButtonHidden = data.isLegendButtonHidden
            $scope.isFullscreenButtonHidden = data.isFullscreenButtonHidden

            let firstSerieChartTypeName;
            for (let key in ChartType) {
                if (ChartType[key] == firstSerieChartType)
                    firstSerieChartTypeName = key.toLowerCase()
            }

            let isLineChart = true;
            for (let key in PieChartType) {
                if (PieChartType[key] == firstSerieChartType)
                    isLineChart = false;
            }
            $scope.isLineChart = isLineChart;

            const series = data.series.filter((serie: DashboardChartSeries) => {
                let isTypeInPieCharts = Object.keys(PieChartType).filter(key => PieChartType[key] == serie.seriesType).length > 0 ? true : false;
                if (isLineChart) {
                    if (isTypeInPieCharts) return false;
                    else {
                        return Object.keys(ChartType).filter(key => ChartType[key] == serie.seriesType).length > 0 ? true : false;
                    }
                }
                else {
                    return isTypeInPieCharts;
                }
            })

            const valueColors = series.map(serie => {
                var value = ''
                if (serie.seriesPoints && serie.seriesPoints[0] && serie.seriesPoints[0].xValue) value = serie.seriesPoints[0].xValue
                return {
                    color: serie.seriesColor,
                    value: value,
                    caption: serie != undefined && serie.seriesCaption != undefined ? serie.seriesCaption.description : ''
                }
            });

            const chartSeries = isLineChart ? this.getLineChartSeries(series, ChartDirectiveController.colors, ChartDirectiveController.regexp) : this.getPieChartSeries(series, ChartDirectiveController.colors, ChartDirectiveController.regexp)
            hasZeroValue = chartSeries.hasZeroValue

            let titleX: string = 'Title X'
            if (series[0] && series[0].xCaption) {
                titleX = series[0].xCaption.description
            } else if (series) {
                titleX = ''
            }

            let titleY: string = 'Title Y'
            if (series[0] && series[0].yCaption) {
                titleY = series[0].yCaption.description
            } else if (series) {
                titleY = ''
            }

            $timeout(() => {
                $scope.options = {
                    adaptiveLayout: {
                        width: 10,
                        height: 10
                    },
                    dataSource: new DataSource({
                        load: () => {
                            var deferred = $.Deferred()
                            var dataSource = $scope.isLineChart ? this.getDataSource(this.actualSeries) : this.getPieChartDataSource(this.actualSeries)
                            $scope.isDataSourceEmpty = dataSource.length === 0;
                            deferred.resolve(dataSource, { totalCount: dataSource.length })
                            return deferred.promise()
                        }
                    }),
                    type: firstSerieChartTypeName,
                    customizePoint: point => {
                        if (!isLineChart) {
                            let color;
                            valueColors.forEach(el => {
                                if (el.caption === point.argument)
                                    color = el.color
                            })
                            return { color }
                        }
                        else return undefined;
                    },
                    resolveLabelOverlapping: "shift",
                    ignoreEmptyPoints: true,
                    series: chartSeries.series,
                    size: {
                        height: '100%'
                    },
                    innerRadius: 0.8, //!TODO need to configure on WS
                    title: {
                        text: data.chartTitle && data.titlePosition !== Enums.Alignment.Unknown ? data.chartTitle.description : '',
                        font: {
                            size: 20,
                            weight: 600,
                            color: data.titleColor ? data.titleColor : '#232323'
                        },
                        horizontalAlignment: this.getTitleHorisontalPosition(data)
                    },
                    legend: {
                        font: {
                            color: data.fontColor ? data.fontColor : '#767676'
                        },
                        horizontalAlignment: HorizontalAlignment.Center,
                        itemTextPosition: $scope.isLineChart ? HorizontalAlignment.Right : 'bottom',
                        visible: isLineChart && data.isLegendValueVisible ? ($scope.isLineChart && data.correlationType != CorrelationType.Server ? true : data.isLegendValueVisible) : data.isLegendValueVisible,
                        customizeText: (seriesInfo: any) => {
                            if ($scope.isLineChart) {
                                return seriesInfo.seriesName
                            } else {
                                const serie: DashboardChartSeries = data.series[seriesInfo.pointIndex]
                                let value: any

                                if (serie.seriesPoints && serie.seriesPoints.length > 0) {
                                    value = serie.seriesPoints[0].xValue
                                }
                                return seriesInfo.pointName + ' \n' + value || ''
                            }
                        }
                    },
                    argumentAxis: {
                        grid: {
                            color: data.axisGridColor ? data.axisGridColor : '#d3d3d3',
                            visible: !data.isVerticalGridHidden,
                        },
                        title: {
                            text: !data.isXAxisTitleHidden ? titleX : '',
                            font: {
                                color: data.axisXColor ? data.axisXColor : '#767676'
                            }
                        },
                        argumentType: axisXType,
                        label: {
                            font: {
                                color: data.fontColor ? data.fontColor : '#767676'
                            },
                            customizeText: (options) => {
                                return this.formatSeriesDate(options.value, axisXType)
                            }
                        },
                        valueMarginsEnabled: false,
                        visible: true,
                        color: data.axisXColor ? data.axisXColor : '#d3d3d3'
                    },
                    valueAxis: {
                        grid: {
                            color: data.axisGridColor ? data.axisGridColor : '#d3d3d3',
                            visible: !data.isHorizontalGridHidden
                        },
                        visible: true,
                        title: {
                            text: !data.isYAxisTitleHidden ? titleY : '',
                            font: {
                                color: data.axisYColor ? data.axisYColor : '#767676'
                            }
                        },
                        min: hasZeroValue ? 0 : undefined,
                        label: {
                            font: {
                                color: data.fontColor ? data.fontColor : '#767676'
                            }
                        },
                        color: data.axisYColor ? data.axisYColor : '#767676'
                    },
                    tooltip: {
                        enabled: !data.isTooltipHidden,
                        shared: true,
                        color: data.tooltipBackgroundColor ? data.tooltipBackgroundColor : '#fff',
                        border: {
                            color: data.tooltipBackgroundColor ? data.tooltipBackgroundColor : '#d3d3d3'
                        },
                        customizeTooltip: (point: any) => {
                            let color: string = point.point.getColor()
                            const value: string = point.valueText
                            const serieName: string = $scope.options.valueAxis.title.text
                            const argument: any = (axisXType == "datetime") ? moment(new Date(point.argument)).format(window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')) : point.argument
                            const lineChartTooltip: string = "<strong><span style='color:'" + color + ";'>" + serieName + ": </span>" + "<span style='color:'" + data.tooltipValueColor ? data.tooltipValueColor : '' + ";'>" + value + "</span>" + " " + "</strong><br/>" + argument;
                            const pieChartToolTip: string = `${point.value} (${point.percentText})`

                            let html: string = '<div>';
                            let arg: string = "";
                            let tagMem: string = "";
                            if (point.points) {
                                point.points.forEach((pt: any) => {
                                    const pointObject: any = pt.point
                                    const series: DevExpress.viz.dxChartSeries = <any>pointObject.series
                                    const options: { unit: string } = series && series['_options'] ? series['_options'] : null
                                    const unitName: string = options && options.unit ? options.unit : ''
                                    const color: string = pointObject.getColor()
                                    const value: string = pt.valueText

                                    const argument: string = this.formatSeriesDate(pt.argument, axisXType)

                                    if (argument != arg) {
                                        arg = argument;
                                        html += "<strong><span style='color:" + (data.tooltipValueColor ? data.tooltipValueColor : '') + ";'><u>" + argument + "</u></span></strong><br/>";
                                    }
                                    html += "<strong><span style='color:" + color + ";'>" + "&nbsp&nbsp" + pt.seriesName.replace('undefined: ', '') + ":</span> " + "<span style='color:" + (data.tooltipValueColor ? data.tooltipValueColor : '') + ";'>" + value + "</span>" + " " + encloseUnit(unitName) + "</strong><br/>"
                                })
                            } else {
                                html += point.value
                            }
                            html += '</div>'

                            return { html: isLineChart ? html : pieChartToolTip }
                        },
                        zIndex: 2002,
                    },
                    onInitialized: (e: any) => {
                        this.chart = e.component

                        $scope.$on(EventsNames.DASHBOARD_UPDATE_CHART_SOURCE + $scope.data.id, (event, ...args: any[]) => {
                            if (_.first(args) != null) {
                                this.sourceUpdating = true
                                data = _.first(args)
                                this.actualSeries = data.series
                                this.chart.option('dataSource')
                                    .load()
                                    .then(() => {
                                        setTimeout(() => {
                                            this.sourceUpdating = false
                                        }, 500)
                                    })
                            }
                        })

                        $scope.$on(EventsNames.DASHBOARD_UPDATE, (event, ...args) => {
                            const delay: DashboardDelay = args[0]
                            delay.time += DashboardRefreshControlDelay
                            $timeout(() => {
                                try {
                                    this.chart.render()
                                } catch (e) { }
                            }, delay.time)
                        })

                        if ($scope.data.isTableVisible) {
                            this.initElementsForTable(data.id)
                        }
                    },
                    onPointClick: e => {
                        this.onSerieClick(e)
                    },
                    onLegendClick: e => {
                        const currentSeries: DevExpress.viz.baseSeriesObject = e.component.getSeriesByPos(e.target.index);
                        if (currentSeries) {
                            if (currentSeries.isVisible())
                                currentSeries.hide()
                            else
                                currentSeries.show()
                        }
                    },
                    onDrawn: (e: any) => {
                        if ($scope.dashboardModel.idStartupIndicator === data.id && data.startupSerie && !this.sourceUpdating) {
                            const serie: DashboardChartSeries[] = data.series.filter(x => x.seriesName === data.startupSerie)
                            if (serie.length) {
                                const res: {
                                    referenceType: number,
                                    referenceData: number[]
                                } = this.getAllReferenceObjects(this.actualSeries, serie[0].seriesCaption.description)

                                if (res.referenceData != null && res.referenceData.length > 0) {
                                    this.$scope.$root.$broadcast(EventsNames.DASHBOARD_CHART_POINT_CLICKED, res.referenceData, res.referenceType)
                                }
                            }
                        }
                    }
                }
            }, 500)
        }
        createChart()

        var isNumeric = (n) => {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        var encloseUnit = (unit) => {
            return unit.trim() ? "[" + unit + "]" : ""
        }

        if (data.correlationType != CorrelationType.Server && (!data.isFullscreenButtonHidden || !data.isLegendButtonHidden))
            $scope.chartHeight = {
                height: 'calc(100% - ' + 36 + 'px)',
            }
        else {
            $scope.chartHeight = {
                height: '100%'
            }
        }

        $scope.$on(EventsNames.DASHBOART_GRID_ROW_SELECTED, (event: ng.IAngularEvent, ...args: any[]) => {
            const referenceValues: any[] = args[0] || []
            const referenceType: number = args[1]
            const correlationType: number = data.correlationType
            if (correlationType == CorrelationType.None) {
                return
            }

            this.referenceValues = referenceValues
            this.referenceType = referenceType

            if (referenceValues.length > 0) {
                if (correlationType == CorrelationType.Local) {
                    return
                }
                if (correlationType == CorrelationType.Server) {
                    let idDataTypes: number[] = []
                    data.series.forEach(serie => {
                        if (serie.referenceType == referenceType) {
                            idDataTypes.push(serie.yIdDataTypeFormat)
                        }
                    })
                    if (idDataTypes.length > 0) {
                        this.getMeasurements(idDataTypes, $scope.datePickerBridge.fromDate, $scope.datePickerBridge.toDate)
                    }
                }
            }
            else {
                // Wtf is below? Why series are resetting?
                this.actualSeries.forEach(serie => {
                    if (serie.referenceType == this.referenceType) {
                        serie.seriesPoints = []
                    }
                })
                if (this.chart) {
                    this.chart.option({ series: [] })
                    this.chart.option('dataSource').load()
                    if (this.grid) {
                        this.grid.option('dataSource', [])
                    }
                }
            }
        })

        $scope.$on(EventsNames.DASHBOARD_MAP_MARKER_CLICKED, (event: ng.IAngularEvent, ...args: any[]) => {
            var selectedMarker = args[0]
            var referenceType: number = args[1]
            var correlationType: number = data.correlationType
            this.referenceValues = [selectedMarker.id]
            this.referenceType = referenceType

            if (selectedMarker) {
                if (correlationType == CorrelationType.None) return
                if (correlationType == CorrelationType.Local) return
                if (correlationType == CorrelationType.Server) {
                    let idDataTypes: number[] = []
                    data.series.forEach(serie => {
                        if (serie.referenceType == referenceType) {
                            idDataTypes.push(serie.yIdDataTypeFormat)
                        }
                    })
                    if (idDataTypes.length > 0) {
                        this.getMeasurements(idDataTypes, $scope.datePickerBridge.fromDate, $scope.datePickerBridge.toDate)
                    }
                }
            }
        })

        $scope.resizeButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.FULLSCREEN, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Fullscreen),
            onClick: e => {
                $scope.resizeChart()
            }
        }
    }

    // TODO: otypować date
    loadMeasurementsFromPeriod(idDataTypes: number[], fromDate, toDate, selectedPeriod) {
        var selectedPeriodName = selectedPeriod.id
        this.loadLatest = selectedPeriod.id == "latest"
        return this.getData(idDataTypes, fromDate, toDate)
    }

    // TODO: otypować date
    getData(idDataTypes: number[], fromDate, toDate) {
        this.$scope.loading = true
        return this.getRequest(idDataTypes, fromDate, toDate).then(req => {
            var defer = this.$q.defer<MeasureCollection[]>()
            var promise: DataProviderRequest<MeasureCollection[]> = null
            var columns = req.columns.map(c => c.id)
            if (!this.loadLatest) {
                if (req.locationIds) {
                    promise = this.userSession.getDataProvider().Measurements.getMeasurementsFilter(req.locationIds, null, null, columns, req.dateFrom, req.dateTo)
                } else if (req.deviceIds) {
                    promise = this.userSession.getDataProvider().Measurements.getMeasurementsFilter(null, req.deviceIds, null, columns, req.dateFrom, req.dateTo)
                } else if (req.meterIds) {
                    promise = this.userSession.getDataProvider().Measurements.getMeasurementsFilter(null, null, req.meterIds, columns, req.dateFrom, req.dateTo)
                }
            } else {
                if (req.locationIds) {
                    promise = this.userSession.getDataProvider().Measurements.getLatestMeasurementsFilter(req.locationIds, null, null, columns)
                } else if (req.deviceIds) {
                    promise = this.userSession.getDataProvider().Measurements.getLatestMeasurementsFilter(null, req.deviceIds, null, columns)
                } else if (req.meterIds) {
                    promise = this.userSession.getDataProvider().Measurements.getLatestMeasurementsFilter(null, null, req.meterIds, columns)
                }
            }

            if (promise)
                promise.then(collection => {
                    this.$scope.loading = false
                    defer.resolve(collection)
                })
            else {
                this.$scope.loading = false
                defer.resolve([])
            }
            return defer.promise
        })
    }

    // TODO: otypować date
    getMeasurements(idDataTypes: number[], fromDate, toDate) {
        if (!this.selectedPeriod) this.selectedPeriod = {
            id: "custom",
            title: i18n("Common", "Custom")
        }

        this.userSession.getDataProvider().Operator.getOperatorSettings(this.userSession.getLoggedOperator().idOperator, [Enums.SimaxOperatorSetting.CurrentLanguage]).then(settings => {
            let idLanguage = settings[0]

            this.loadMeasurementsFromPeriod(idDataTypes, fromDate, toDate, this.selectedPeriod).then(measureCollection => {
                let data = this.measurements.measureCollectionsToMeasurementModels(measureCollection)
                if (data && data.length > 0) {
                    this.actualMeasurements = measureCollection
                    var dataType = this.localDictionary.getDataTypeSync(data[0].dataType)
                    var chartTypeId: number
                    this.localDictionary.getChartTypeForDataType(dataType.idDataType).then(chartType => {
                        for (var field in ChartType) {
                            if (field.toLowerCase() == chartType.toLowerCase())
                                chartTypeId = ChartType[field]
                        }

                        var descrModel = <DescrModel>{
                            allLanguagesDescription: [],
                            description: dataType.caption,
                            idDescr: 0,
                            idLanguage: idLanguage,
                            opState: CommonHelper.ChangeState.Loaded
                        }

                        var sorted: iSort[] = []
                        data.forEach(d => {
                            if (sorted.length == 0) {
                                sorted.push({
                                    info: {
                                        dataType: d.dataType,
                                        idLoc: d.idLocation,
                                        IdMeter: d.idMeter,
                                        serialNbr: d.serialNbr
                                    }, measurements: []
                                })
                            }
                            else {
                                if (!sorted.some(s => {
                                    return d.dataType == s.info.dataType && d.idLocation == s.info.idLoc && d.idMeter == s.info.IdMeter && d.serialNbr == s.info.serialNbr
                                })) {
                                    sorted.push({ info: { dataType: d.dataType, idLoc: d.idLocation, IdMeter: d.idMeter, serialNbr: d.serialNbr }, measurements: [] })
                                }
                            }
                        })
                        data.forEach(d => {
                            sorted.forEach(s => {
                                if (d.dataType == s.info.dataType && d.idLocation == s.info.idLoc && d.idMeter == s.info.IdMeter && d.serialNbr == s.info.serialNbr) {
                                    s.measurements.push(d)
                                    return
                                }
                            })
                        })
                        var filteredSeries: any[] = []
                        var newSeries: DashboardChartSeries[] = []

                        var hasSeries = this.$scope.data.series && this.$scope.data.series.length > 0
                        let unitName: string = null

                        sorted.forEach((s, index) => {
                            var dataType = this.localDictionary.getDataTypeSync(s.info.dataType)
                            let newSerie = {
                                referenceType: this.referenceType,
                                seriesCaption: hasSeries ? this.$scope.data.series[0].seriesCaption : {
                                    allLanguagesDescription: [],
                                    description: (s.info.serialNbr ? s.info.serialNbr + ': ' : '') + dataType.caption,
                                    idDescr: 0,
                                    idLanguage: idLanguage,
                                    opState: CommonHelper.ChangeState.Loaded
                                },
                                seriesName: dataType.caption,
                                seriesType: chartTypeId,
                                xCaption: hasSeries ? this.$scope.data.series[0].xCaption : {
                                    allLanguagesDescription: [],
                                    description: i18n('Common', 'Date'),
                                    idDescr: 0,
                                    idLanguage: idLanguage,
                                    opState: CommonHelper.ChangeState.Loaded
                                },
                                xIdDataTypeFormat: null,
                                xName: 'XSerieName' + index,
                                xType: SeriesTypeNames.DateTime,
                                xTypeName: SeriesTypeNames.DateTime,
                                yCaption: hasSeries ? this.$scope.data.series[0].yCaption : { idDescr: 0, description: dataType.caption, idLanguage: idLanguage, opState: 0, allLanguagesDescription: [] },
                                yIdDataTypeFormat: s.info.dataType,
                                yName: 'YSerieName' + index,
                                yType: SeriesTypeNames.Double,
                                yTypeName: SeriesTypeNames.Double,
                                seriesColor: null,
                                seriesPoints: s.measurements.map(point => { return <DashboardChartSeriesPoint>{ referenceData: this.referenceValues, xValue: point.date, yValue: point.value } })
                            }
                            newSerie['unit'] = dataType.unitName
                            newSeries.push(newSerie)
                            if (dataType.unitName)
                                unitName = dataType.unitName
                        })
                        this.actualSeries = newSeries

                        this.updateDataSourceInGrid()
                        var datas: DashboardChartDataModel = this.$scope.data
                        const firstSerieChartType = chartTypeId
                        let isLineChart = true;
                        for (let key in PieChartType) {
                            if (PieChartType[key] == firstSerieChartType)
                                isLineChart = false;
                        }
                        this.$scope.isLineChart = isLineChart;
                        var series = newSeries.filter(serie => {
                            let isTypeInPieCharts = Object.keys(PieChartType).filter(key => PieChartType[key] == serie.seriesType).length > 0 ? true : false;
                            if (isLineChart) {
                                if (isTypeInPieCharts) return false;
                                else {
                                    return Object.keys(ChartType).filter(key => ChartType[key] == serie.seriesType).length > 0 ? true : false;
                                }
                            }
                            else {
                                return isTypeInPieCharts;
                            }
                        })

                        const valueColors = series.map(serie => {
                            var value = ''
                            if (serie.seriesPoints && serie.seriesPoints[0] && serie.seriesPoints[0].xValue) value = serie.seriesPoints[0].xValue
                            return {
                                color: serie.seriesColor,
                                value: value,
                                caption: serie != undefined && serie.seriesCaption != undefined ? serie.seriesCaption.description : ''
                            }
                        });

                        const chartSeries = isLineChart ? this.getLineChartSeries(series, ChartDirectiveController.colors, ChartDirectiveController.regexp) : this.getPieChartSeries(series, ChartDirectiveController.colors, ChartDirectiveController.regexp)

                        this.$scope.isDataSourceEmpty == true
                        this.$scope.options.series = chartSeries.series
                        this.chart.option({ series: chartSeries.series })
                        if (unitName && this.$scope.data.series.length > 0 && this.$scope.data.series[0].yCaption && this.$scope.data.series[0].yCaption.description) {
                            this.chart.option('valueAxis.title', this.$scope.data.series[0].yCaption.description + ' ' + unitName)
                        }
                        this.chart.option('dataSource').load()
                        this.chart.render()
                    })
                } else {
                    this.actualMeasurements = []
                    this.actualSeries = this.$scope.data.series
                    this.updateDataSourceInGrid()
                    this.$scope.isDataSourceEmpty == true
                    this.$scope.options.series = []
                    this.chart.option({ series: [] })
                    this.chart.option('dataSource').load()
                    this.chart.render()
                }
            })
        })
    }

    getRequest(idDataTypes: number[], fromDate, toDate) {
        var req = new MeasurementsRequestModel()

        return this.localDictionary.getDataTypes(idDataTypes).then(columns => {
            req.columns = columns

            switch (this.referenceType) {
                case CommonHelper.IdLocation:
                    req.locationIds = this.referenceValues
                    break;
                case CommonHelper.IdDevice:
                    req.deviceIds = this.referenceValues
                    break;
                case CommonHelper.IdMeter:
                    req.meterIds = this.referenceValues
                    break;
            }

            req.dateFrom = moment(fromDate).toDate()
            req.dateFrom.setHours(0, 0, 0, 0)
            var momentFrom = moment(fromDate)
            req.dateFrom = momentFrom.add(momentFrom.utcOffset(), 'minutes').toDate()

            req.dateTo = moment(toDate).toDate()
            req.dateTo.setHours(23, 59, 59, 999)
            var momentTo = moment(toDate)
            req.dateTo = momentTo.add(momentTo.utcOffset(), 'minutes').toDate()

            return req
        })
    }

    refreshMeasurements() {
        let idDataTypes: number[] = []
        this.actualSeries.forEach(serie => {
            if (serie.referenceType == this.referenceType) {
                idDataTypes.push(serie.yIdDataTypeFormat)
            }
        })
        this.getMeasurements(idDataTypes, this.$scope.datePickerBridge.fromDate, this.$scope.datePickerBridge.toDate)
    }

    updateDataSourceInGrid() {
        if (this.grid) {
            this.measurements.getColumnsAndRowsFromMeasureCollection(this.grid['dataTypesInColumns'], this.actualMeasurements).then(data => {
                this.$scope.$broadcast(EventsNames.UPDATE_GRID_COLUMNS + this.gridId, data.columns)
                this.grid.option({
                    dataSource: new DataSource(data.rows),
                    columns: data.columns.map(column => {
                        TableController.addCustomFiltersToDxColumn(column, column.dataType, { type: column.dataType }, false, null, null, null)
                        return column
                    })
                })
            })
        }
    }

    initElementsForTable(id: number) {
        var datesPopup: DevExpress.ui.dxPopup = null
        var positionPopover: DevExpress.ui.dxPopover = null
        var preferencesPopover: DevExpress.ui.dxPopover = null
        var settingsPopover: DevExpress.ui.dxPopover = null

        var gridTypesItems = [this.GRID_TYPES.IN_COLUMNS, this.GRID_TYPES.IN_ROWS, this.GRID_TYPES.FIX_COLUMNS]

        // TODO: zmienić zapis / odczyt
        let selectedGridType = CommonHelper.getValueFromLocalStorage("DashboardChartGridType" + id)
        if (selectedGridType == null)
            selectedGridType = this.GRID_TYPES.IN_ROWS.id

        // TODO: zmienić zapis / odczyt
        let gridColumnFixed = CommonHelper.getValueFromLocalStorage("DashboardChartGridColumnFix" + id)
        if (gridColumnFixed == null)
            gridColumnFixed = false

        let fixedButton: JQuery = null

        this.$scope.gridOptions = {
            type: GridTypes.NO_SEARCH_BAR_PAGINATED_SMALL,
            columns: [],
            columnAutoWidth: gridColumnFixed,
            allowColumnReordering: false,
            onInitialized: e => {
                this.grid = e.component
                this.gridId = e.tableId
                this.grid['dataTypesInColumns'] = selectedGridType == this.GRID_TYPES.IN_COLUMNS.id
                this.updateDataSourceInGrid()
            },
            name: "DashboardChartGrid" + id,
            buttonsOptions: {
                enabled: false
            },
            paging: {
                pageSize: 50,
                enabled: true
            },
            addCustomFilters: true
        }

        let setGridType = (type: string) => {
            if (type == this.GRID_TYPES.FIX_COLUMNS.id) {
                gridColumnFixed = !gridColumnFixed

                // TODO: zmienić zapis / odczyt
                CommonHelper.setValueToLocalStorage("DashboardChartGridColumnFix" + id, gridColumnFixed)

                if (fixedButton) {
                    if (gridColumnFixed) {
                        fixedButton.addClass("dashboard-chart-grid-active-button")
                    } else {
                        fixedButton.removeClass("dashboard-chart-grid-active-button")
                    }
                }

                if (this.grid) {
                    var columns = []
                    for (var i = 0; i < this.grid.columnCount(); i++) {
                        columns.push(this.grid.columnOption(i))
                        columns[i].width = null
                    }

                    this.grid.option({
                        columnAutoWidth: gridColumnFixed,
                        columns: columns
                    })
                }
            } else {
                selectedGridType = type
                // TODO: zmienić zapis / odczyt
                CommonHelper.setValueToLocalStorage("DashboardChartGridType" + id, selectedGridType)
                this.grid['dataTypesInColumns'] = selectedGridType == this.GRID_TYPES.IN_COLUMNS.id
                this.updateDataSourceInGrid()

            }
        }

        this.$scope.preferencesListOptions = {
            items: gridTypesItems,
            onItemClick: e => {
                setGridType(e.itemData.id)
                e.component.repaint()
                preferencesPopover.hide()
                if (settingsPopover)
                    settingsPopover.hide()
            },
            onItemRendered: e => {
                if (e.itemData.id == this.GRID_TYPES.FIX_COLUMNS.id) {
                    fixedButton = e.itemElement
                    if (gridColumnFixed) {
                        fixedButton.addClass("dashboard-chart-grid-active-button")
                    } else {
                        fixedButton.removeClass("dashboard-chart-grid-active-button")
                    }
                } else if (e.itemData.id == selectedGridType) {
                    e.itemData.disabled = true
                } else {
                    e.itemData.disabled = false
                }
            }
        }
        this.$scope.preferencesButtonListOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REORDER, this.userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Preferences),
            items: gridTypesItems,
            selectedItem: gridTypesItems.filter(type => type.id == selectedGridType)[0],
            onItemClick: (e, item, index) => {
                setGridType(item.id)
                e.component.repaint()
                return false
            },
            onItemRendered: e => {
                if (e.itemData.id == this.GRID_TYPES.FIX_COLUMNS.id) {
                    fixedButton = e.itemElement
                    if (gridColumnFixed) {
                        fixedButton.addClass("dashboard-chart-grid-active-button")
                    } else {
                        fixedButton.removeClass("dashboard-chart-grid-active-button")
                    }
                } else if (e.itemData.id == selectedGridType) {
                    e.itemData.disabled = true
                } else {
                    e.itemData.disabled = false
                }
            }
        }
        this.$scope.preferencesPopoverOptions = {
            width: 200,
            position: HorizontalAlignment.Right,
            onInitialized: e => {
                preferencesPopover = e.component
            },
            onShowing: e => {
                e.component.content().css({
                    'padding': 0,
                    'text-align': HorizontalAlignment.Center,
                    'border-radius': 'inherit'
                })
            }
        }

        let setPosition = (index) => {
            switch (index) {
                case 0:
                    this.$scope.chartWithTableClass = 'row-mode'
                    break;
                case 1:
                    this.$scope.chartWithTableClass = 'row-mode invert-mode'
                    break;
                case 2:
                    this.$scope.chartWithTableClass = ''
                    break;
                case 3:
                    this.$scope.chartWithTableClass = 'invert-mode'
                    break;
                case 4:
                    this.$scope.chartWithTableClass = 'chart-mode'
                    break;
                case 5:
                    this.$scope.chartWithTableClass = 'grid-mode'
                    break;
            }
        }

        let positions = ["ChartOnTheLeft", "ChartOnTheRight", "ChartOnTheTop", "ChartOnTheBottom", "FullScreenChart", "FullScreenGrid"].map(key => i18n("Grid", key))

        // TODO: zmienić zapis / odczyt
        let index = CommonHelper.getValueFromLocalStorage("DashboardChartGridPosition" + id)
        if (index == null) index = 0
        setPosition(index)
        this.$scope.positionPopoverOptions = {
            width: 160,
            position: HorizontalAlignment.Right,
            onInitialized: e => {
                positionPopover = e.component
            },
            onShowing: e => {
                e.component.content().css({
                    'padding': 0,
                    'text-align': HorizontalAlignment.Center,
                    'border-radius': 'inherit'
                })
            }
        }
        this.$scope.positionListOptions = {
            items: positions,
            onItemClick: e => {
                setPosition(e.itemIndex)
                positionPopover.hide()
                if (settingsPopover)
                    settingsPopover.hide()

                this.$timeout(() => {
                    this.grid.updateDimensions()
                    if (this.chart)
                        this.chart.render()
                }, 200)
            }
        }
        this.$scope.positionButtonListOptions = {
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangePosition),
            template: TemplateHelper.getIcon(ConfigHelper.Icon.SIZE, this.userSession),
            items: positions,
            selectedItem: positions[index],
            onItemClick: (e, item, index) => {
                setPosition(index)

                // TODO: zmienić zapis / odczyt
                CommonHelper.setValueToLocalStorage("DashboardChartGridPosition" + id, index)

                this.$timeout(() => {
                    this.grid.updateDimensions()
                    if (this.chart)
                        this.chart.render()
                }, 200)

                return false
            }
        }

        let settings = {
            itemsPosition: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ItemsPosition), ConfigHelper.Icon.SIZE) },
            gridLayout: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Preferences), ConfigHelper.Icon.REORDER) },
            dates: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DateRange), ConfigHelper.Icon.DATE_RANGE) },
            refresh: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Refresh), ConfigHelper.Icon.REFRESH) },
            export: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Export), ConfigHelper.Icon.EXPORT) }
        }

        let settingsList = [
            settings.itemsPosition, settings.gridLayout, settings.dates, settings.refresh, settings.export
        ]

        this.$scope.settingsButtonListOptions = {
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowOptions),
            template: TemplateHelper.getIcon(ConfigHelper.Icon.SHOW_OPTIONS, this.userSession),
            items: settingsList,
            selectedItem: null,
            onItemClick: (e, item, index) => {
                switch (item) {
                    case settings.itemsPosition:
                        if (positionPopover) {
                            positionPopover.option('target', e.element.find('.dx-item:eq(' + index + ')'))
                            positionPopover.show()
                        }
                        return true
                    case settings.gridLayout:
                        if (preferencesPopover) {
                            preferencesPopover.option('target', e.element.find('.dx-item:eq(' + index + ')'))
                            preferencesPopover.show()
                        }
                        return true
                    case settings.dates:
                        if (datesPopup)
                            datesPopup.show()
                        return false
                    case settings.refresh:
                        this.refreshMeasurements()
                        return false
                    case settings.export:
                        this.exportMeasurements(selectedGridType)
                        return false
                }
                return true
            },
            onInitialize: popover => {
                settingsPopover = popover
            }
        }

        this.$scope.exportGridButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.EXPORT, this.userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Export),
            onClick: () => {
                this.exportMeasurements(selectedGridType)
            }
        }

        this.$scope.refreshButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REFRESH, this.userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Refresh),
            onClick: () => {
                this.refreshMeasurements()
            }
        }

        this.$scope.datesPopupOptions = {
            maxWidth: 250,
            maxHeight: 300,
            title: i18n('Grid', 'DateRange'),
            visible: false,
            onInitialized: e => {
                datesPopup = e.component
            }
        }

        this.$scope.datesPopupToolbarOptions = {
            items: [
                {
                    location: HorizontalAlignment.Center,
                    widget: 'dxButton',
                    options: {
                        text: i18n('Common', 'Cancel'),
                        onClick: () => {
                            if (datesPopup)
                                datesPopup.hide()
                        }
                    }
                },
                {
                    location: HorizontalAlignment.Center,
                    widget: 'dxButton',
                    options: {
                        text: i18n('Common', 'Ok'),
                        onClick: () => {
                            if (datesPopup)
                                datesPopup.hide()
                            this.refreshMeasurements()
                        }
                    }
                }
            ]
        }

        this.$timeout(() => {
            const header = this.$element.find('.chart-header')
            let headerWidth = 0
            header.children().each((i, e) => {
                headerWidth += angular.element(e).width()
            })
            this.$scope.$watch(() => {
                return this.$element.width()
            }, _.debounce(width => {
                if (headerWidth > width) {
                    this.$scope.datePickerBridge.isSmallScreen = true
                    this.$scope.isSmallScreen = true
                } else {
                    this.$scope.datePickerBridge.isSmallScreen = false
                    this.$scope.isSmallScreen = false
                }
            }, 2000))
        })
    }

    exportMeasurements(selectedGridType: string) {
        if (this.grid) {
            let idDataTypes: number[] = []
            this.actualSeries.forEach(serie => {
                if (serie.referenceType == this.referenceType) {
                    idDataTypes.push(serie.yIdDataTypeFormat)
                }
            })
            this.getRequest(idDataTypes, this.$scope.datePickerBridge.fromDate, this.$scope.datePickerBridge.toDate).then(reqeust => {
                switch (selectedGridType) {
                    case this.GRID_TYPES.IN_COLUMNS.id:
                        reqeust.measurementViewStyle = 1
                        break
                    case this.GRID_TYPES.IN_ROWS.id:
                        reqeust.measurementViewStyle = 2
                        break
                }

                MeasurementsController.exportMeasurements(reqeust, this.grid.option('columns'), this.localDictionary, this.$q, this.api)
            })
        }
    }

    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    getReferenceObjects(valueX, series: any[], seriesName: string) {
        for (var i = 0; i < series.length; ++i) {
            if (series[i].seriesName.description && series[i].seriesName.description != seriesName)
                continue

            for (var j = 0; j < series[i].seriesPoints.length; ++j) {
                if (series[i].seriesPoints[j].xValue == valueX) {
                    var result = {
                        referenceType: series[i].referenceType,
                        referenceData: series[i].seriesPoints[j].referenceData
                    }
                    return result
                }
            }
        }
        return null
    }

    getPieChartReferenceObjects(caption: string, series: any[]) {
        for (let i = 0; i < series.length; i++) {
            if (series[i].seriesCaption.description == caption) {
                const result = {
                    referenceType: series[i].referenceType,
                    referenceData: series[i].seriesPoints[0].referenceData
                }
                return result;
            }
        }
    }

    getAllReferenceObjects(series: any[], seriesName: string): { referenceType: number, referenceData: number[] } {
        const distinct = (value: number | string, index: number, self: (number | string)[]) => {
            return self.indexOf(value) === index
        }

        for (let i = 0; i < series.length; ++i) {

            if ((this.$scope.isLineChart && series[i].seriesName.description && series[i].seriesName.description != seriesName) || (!this.$scope.isLineChart && series[i].seriesCaption.description != seriesName)) {
                continue
            }

            const result: { referenceType: number, referenceData: number[] } = {
                referenceType: series[i].referenceType,
                referenceData: []
            }

            for (let j = 0; j < series[i].seriesPoints.length; ++j) {
                result.referenceData = series[i].seriesPoints[j].referenceData
            }

            result.referenceData = result.referenceData.filter(distinct)
            return result
        }

        return null
    }

    getDataSource(series: any[]) {
        var dataSource = []
        for (var i = 0; i < series.length; ++i) {
            if (series[i].seriesPoints) {
                for (var j = 0; j < series[i].seriesPoints.length; ++j) {
                    var existData = null

                    var xValue = series[i].seriesPoints[j].xValue
                    if (series[i].xTypeName == SeriesTypeNames.DateTime) {
                        xValue = moment(xValue).toDate()
                    }

                    var yValue = series[i].seriesPoints[j].yValue
                    if (!isNaN(yValue)) {
                        yValue = parseFloat(yValue)
                    } else if (series[i].yTypeName == SeriesTypeNames.DateTime) {
                        yValue = moment(yValue).format(window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
                    }

                    dataSource.forEach((d) => {
                        if (d.day == xValue) existData = d
                    })
                    if (existData) {
                        existData['value' + i] = yValue
                    } else {
                        var newData = { day: xValue }
                        newData['value' + i] = yValue
                        dataSource.push(newData);
                    }
                }
            }
        }
        return dataSource;
    }

    getPieChartDataSource(series: DashboardChartSeries[]) {
        const dataSource: { caption: string, value: any, tag: string, color: string }[] = []

        if (_.isArray(series)) {
            series.forEach((serie: DashboardChartSeries) => {
                if (serie.seriesPoints && serie.seriesPoints.length > 0) {
                    const newData = {
                        caption: serie.seriesCaption.description,
                        value: serie.seriesPoints[0].xValue,
                        tag: serie['color'],
                        color: serie['color']
                    }

                    dataSource.push(newData);
                }
            })
        }

        return dataSource;
    }

    getPieChartSeries(originalSeries: any, colors: any[], regexp: RegExp) {
        let hasZeroValue = false;

        let series = [{
            argumentField: "caption",
            valueField: "value",
            label: {
                visible: this.$scope.data.isSeriesLabelVisible,
                connector: { visible: this.$scope.data.isSeriesLabelVisible },
                customizeText: (str) => `${str.argument}: ${str.value}`,
                font: {
                    color: "#000",
                    size: 16
                }
            }
        }]

        return {
            series: series,
            hasZeroValue: hasZeroValue,
        }
    }

    getLineChartSeries(originalSeries: DashboardChartSeries[], colors: any[], regexp: RegExp) {
        let series = [];
        let hasZeroValue = false;

        if (originalSeries) {
            for (var i = 0; i < originalSeries.length; ++i) {
                if (originalSeries[i]['value' + i] == 0)
                    hasZeroValue = true
                var color;

                if (!originalSeries[i].seriesColor) {
                    if (i < 7) color = colors[i];
                    else color = this.getRandomColor();
                }
                else {
                    if (regexp.test(originalSeries[i].seriesColor))
                        color = 'rgb(' + originalSeries[i].seriesColor + ')';
                    else color = originalSeries[i].seriesColor
                }

                let seriesType = 'Line'
                for (let key in ChartType) {
                    if (ChartType[key] == originalSeries[i].seriesType)
                        seriesType = key.toLowerCase()
                }
                for (let key in PieChartType) {
                    if (PieChartType[key] == originalSeries[i].seriesType)
                        seriesType = key.toLowerCase()
                }

                series.push({
                    argumentField: "day",
                    valueField: "value" + i,
                    name: originalSeries[i].seriesCaption ? originalSeries[i].seriesCaption.description : '',
                    type: seriesType,
                    color: color,
                    point: { visible: true, size: 4, hoverStyle: { size: 3 } },
                    unit: originalSeries[i]['unit']
                })
            }
        }

        return {
            series: series,
            hasZeroValue: hasZeroValue
        }
    }

    checkReferenceType($scope, $state, reference) {
        if (reference && reference.referenceType) {
            this.systemService.openDetailsOrModule({
                idReferenceType: reference.referenceType,
                referenceObjectIds: reference.referenceData
            })
        }
    }

    getTitleHorisontalPosition(data: DashboardChartDataModel): string {
        let position: string = 'center'
        switch (data.titlePosition) {
            case Enums.Alignment.Left:
                position = 'left'
                break
            case Enums.Alignment.Center:
                position = 'center'
                break
            case Enums.Alignment.Right:
                position = 'right'
                break
        }
        return position
    }

    private onSerieClick(e: any): void {
        let reference
        if (this.$scope.isLineChart) {
            reference = this.getReferenceObjects(e.target.argument, this.actualSeries, e.target.series.seriesName ? e.target.series.seriesName.description : '')
        }
        else {
            reference = this.getPieChartReferenceObjects(e.target.argument, this.actualSeries)
        }

        this.useCorrelation(reference)
    }

    private useCorrelation(reference: { referenceType: number, referenceData: number[] }): void {
        if (this.$scope.data.correlationType === CorrelationType.Local || this.$scope.data.correlationType === CorrelationType.Server) {
            if (this.clickTimer) {
                //doubleclick
                clearTimeout(this.clickTimer)
                this.clickTimer = null

                this.checkReferenceType(this.$scope, this.$state, reference)

                if (this.chart != null) {
                    this.chart.hideTooltip()
                }

                if (this.$scope.isChartFullscreen && reference) {
                    this.$scope.resizeChart()
                }
            } else {
                this.clickTimer = setTimeout(() => {
                    //click

                    this.$scope.$root.$broadcast(EventsNames.DASHBOARD_CHART_POINT_CLICKED, reference.referenceData, reference.referenceType)
                    this.clickTimer = null
                }, 250)
            }
        } else {
            this.checkReferenceType(this.$scope, this.$state, reference)
            if (this.chart) {
                this.chart.hideTooltip()
            }
            if (this.$scope.isChartFullscreen && reference) {
                this.$scope.resizeChart()
            }
        }
    }

    //#region Series

    private formatSeriesDate(date: string, seriesType: string): string {
        if (seriesType === "datetime") {
            return moment(date).format(ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_MOMENTJS))
        }

        if (seriesType === "date") {
            return moment(date).format(ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_FORMAT_MOMENTJS))
        }

        if (seriesType === "time") {
            return moment(date).format('HH:mm')
        }

        return date
    }

    //#endregion
}